
import Heading from "./Heading.tsx";

type VideoLinkType = {
  scores: {lesson:number,score: number}[]
  background?: string,
  bg?: string,
  color?: string
}

export default function LessonScores({scores,background,bg,color}:VideoLinkType) {


    return (
      <div>
        <Heading
          label="Bảng điểm tổng hợp UNIT"
          background={background || "black"}
        />

        <Scores
          scores={scores}
          bg={bg}
          color={color}
          background={background}
        />
      </div>
    );
}


function Scores({ background,bg, color,scores }: VideoLinkType) {
  return (
    <div className="">
      <div
        className="flex text-center"
        style={{ background, color: "white", borderBottom: "1px black solid" }}
      >
        <div
          className="flex-4 p-2"
          style={{ borderLeft: "1px black solid" }}
        >
          Lesson
        </div>
        <div
          className="flex-1 p-2"
          style={{ borderLeft: "1px black solid" }}
        >
          E
        </div>
        <div
          className="flex-1 p-2"
          style={{ borderLeft: "1px black solid" }}
        >
          VG
        </div>
        <div
          className="flex-1 p-2"
          style={{ borderLeft: "1px black solid" }}
        >
          G
        </div>
        <div
          className="flex-1 p-2"
          style={{ borderLeft: "1px black solid" }}
        >
          F
        </div>
        <div
          className="flex-1 p-2"
          style={{
            borderLeft: "1px black solid",
            borderRight: "1px black solid",
          }}
        >
          P
        </div>
      </div>
      {scores.map((s, i) => (
        <div
          className="flex text-center"
          style={{ background: bg, color, borderBottom: "black 1px solid" }}
        >
          <div
            className="flex-4 p-2"
            style={{ borderLeft: "1px black solid" }}
          >
            Lesson {s.lesson}
          </div>
          <div
            className="flex-1 p-2"
            style={{ borderLeft: "1px black solid" }}
          >
            {s.score >= 9 ? s.score : ""}
          </div>
          <div
            className="flex-1 p-2"
            style={{ borderLeft: "1px black solid" }}
          >
            {s.score >= 8 && s.score < 9 ? s.score : ""}
          </div>
          <div
            className="flex-1 p-2"
            style={{ borderLeft: "1px black solid" }}
          >
            {s.score >= 7 && s.score < 8 ? s.score : ""}
          </div>
          <div
            className="flex-1 p-2"
            style={{ borderLeft: "1px black solid" }}
          >
            {s.score >= 6 && s.score < 7 ? s.score : ""}
          </div>
          <div
            className="flex-1 p-2"
            style={{
              borderLeft: "1px black solid",
              borderRight: "1px black solid",
            }}
          >
            {s.score < 6 ? s.score : ""}
          </div>
        </div>
      ))}
    </div>
  );
}


